import { WindTurbinesOverview } from "./WindTurbinesOverview";
export default WindTurbinesOverview;
